export default "__VITE_ASSET__bf8cfbab__"